import {dataExportService} from '../services'

const state = {
    loading: false,
}

const actions = {

    create({ dispatch, commit }, params) {
        commit('startRequest')
        return dataExportService.create(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'This will take some time. As soon as the data export is finished, we will send an email to you.', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to start export job: ' + error, { root: true })
            }
        )
    },

    remove({ dispatch, commit }, id) {
        commit('startRequest')
        return dataExportService.remove(id).then(
            response => {
                dispatch('alert/success', 'Export data deleted successfully', { root: true })
                commit('endRequest')
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to remove export data: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    },
}

export const dataExportModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
